module.exports = __webpack_public_path__ + "static/feature-creative-tools@2x-ed4dd69a395130f54017054c4449c652.gif";